import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
// @ts-ignore  Currently there is no types definition for semi-animation-react;
import { Transition } from '@douyinfe/semi-animation-react';
import React from 'react'; // eslint-disable-next-line max-len

const formatStyles = function formatStyles() {
  let styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    placement
  } = props;
  const {
    translate
  } = styles;
  const {
    opacity
  } = styles;
  let transform = '';

  switch (placement) {
    case 'left':
      transform = "translateX(-".concat(translate, "%)");
      break;

    case 'top':
      transform = "translateY(-".concat(translate, "%)");
      break;

    case 'right':
      transform = "translateX(".concat(translate, "%)");
      break;

    case 'bottom':
      transform = "translateY(".concat(translate, "%)");
      break;

    default:
      break;
  }

  return {
    transform,
    opacity
  };
};

export default class SideSheetTransition extends React.PureComponent {
  render() {
    let {
      motion = {}
    } = this.props;
    const {
      children,
      controlled = false,
      visible
    } = this.props;

    if (typeof motion === 'function') {
      motion = motion(this.props);
    } else if (!motion || typeof motion !== 'object') {
      motion = {};
    }

    let extra = {};

    if (controlled) {
      extra = {
        state: visible ? 'enter' : 'leave'
      };
    }

    return /*#__PURE__*/React.createElement(Transition, _Object$assign({
      config: {
        tension: 170,
        friction: 14,
        easing: 'linear',
        duration: 200
      },
      from: {
        translate: 100,
        opacity: {
          val: 0,
          duration: 180
        }
      },
      enter: {
        translate: 0,
        opacity: {
          val: 1,
          duration: 180
        }
      },
      leave: {
        translate: 100,
        opacity: {
          val: 0,
          duration: 180
        }
      }
    }, extra, motion), typeof children === 'function' ? styles => children(formatStyles(styles, this.props)) : children);
  }

}